enum Timezone {
  EUROPE_WARSAW = "Europe/Warsaw",
  UTC = "UTC",
}

export default Timezone;
